import { useContext } from 'react'

import {
  Box, Button, Form, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useProviderPackage, { useProviderPackageForm } from '@hooks/useProviderPackage'

import EntitySelector from '@components/EntitySelector'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

const MODAL_KEY = 'CreateProviderPackageModal'

type ModalCallbacks = {
  createProviderPackage: (payload: HandleCallbackActionParams) => Promise<object>,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  modalKey?: string,
  showModal: boolean,
}

const CreateProviderPackageModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { createProviderPackage } = callbacks

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})

  const initProviderPackage = digObject(modalPayload, 'providerPackage', {})
  const shouldShowProviderSelector = !initProviderPackage.provider_id

  const {
    callbacks: { createProviderPackage: createFn },
    creating,
  } = useProviderPackage()

  const {
    entityState,
    entityState: {
      price,
      provider_id,
      title,
    },
    errors,
    handlers,
    saveEnabled,
    setEntityState,
  } = useProviderPackageForm(initProviderPackage, { validateOn: 'change' })

  const createProviderPackagePayload = {
    callbacks: {
      action: createFn,
    },
    entityParams: entityState,
    shouldRedirect: true,
    toastText: 'Provider Package Created',
  }

  return (
    // @ts-expect-error TS2741
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal} size="small">
      {/*
       // @ts-expect-error TS2559 */}
      <SidebarModal.Header callbacks={callbacks} title="Create" titleSecondLine="Provider Package" />

      <SidebarModal.Content>
        <Box flexDirection="column" flexShrink={0}>
          {shouldShowProviderSelector && (
            <EntitySelector
              callbacks={{
                selectItem: provider => setEntityState({ provider_id: provider ? provider.id : null }),
              }}
              entityKey="providers"
              errorMessage={errors.provider_id}
              label="* Provider"
              selectedItemId={provider_id}
            />
          )}

          <Form.Field
            direction="column"
            errorMessage={errors.title}
            label="* Package Title"
            marginTop={shouldShowProviderSelector ? 'large' : 0}

          >
            <input name="title" value={title} type="text" {...handlers} />
          </Form.Field>

          <Form.Field
            direction="column"
            errorMessage={errors.price}
            label="* Price"
            marginTop="large"
          >
            <input name="price" value={price} type="number" {...handlers} />
          </Form.Field>

        </Box>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={creating}
          // @ts-expect-error TS2345
          onClick={() => createProviderPackage(createProviderPackagePayload)}
          size="large"
        >
          {saveEnabled ? 'Create Provider Package' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <CreateProviderPackageModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
